export default __webpack_public_path__ + "4365fc9d9cbcb19451870cba322afd8c.svg";